<template>
  <modal width="35" :show-modal="showModal" @close-modal="$emit('close-modal')">
    <div class="flex my-4 flex-col text-right gap-4 items-center justify-center">
      <div class="flex justify-between gap-4 font-semibold text-center text-primary-yellow">
        Recipient acknowledged
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="24" height="24" rx="5" fill="white" />
          <path d="M9.27752 15.2659L5.37854 11.3993L4 12.7663L9.27752 18L20 7.36704L18.6215 6.00001L9.27752 15.2659Z"
            fill="#09B78A" />
        </svg>
      </div>
      <div class="flex justify-between w-100">
        <div>
          <p class="text-lightGray">3PL Terminal</p>
          <p>Ifex Jibowu</p>
        </div>
        <div>
          <p class="text-lightGray">Name</p>
          <p>Ifex Jibowu</p>
        </div>
      </div>
      <div class="flex justify-between w-100">
        <div>
          <p class="text-lightGray">Phone Number</p>
          <p>Ifex Jibowu</p>
        </div>
        <div>
          <p class="text-lightGray">Address</p>
          <p>Ifex Jibowu</p>
        </div>
      </div>
      <div class="flex justify-between w-100">
        <div>
          <p class="text-lightGray">State</p>
          <p>Ifex Jibowu</p>
        </div>
        <div>
          <p class="text-lightGray">Email</p>
          <p>Ifex Jibowu</p>
        </div>
      </div>
      <div class="flex justify-between w-100">
        <div>
          <p class="text-lightGray">Delivery Status</p>
          <p class="text-green">Ifex Jibowu</p>
        </div>
        <div>
          <p class="text-lightGray">Receipt code</p>
          <p>****** ***</p>
        </div>
      </div>

      <base-button text="Save" class="my-4" :loading="loading" @click="acknowledgeRequest" />
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    booking: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      reason: "",
      loading: false
    };
  },
  computed: {
    orgId() {
      return this.$store.state.authentication.quantumOrganizationId;
    },
  },
  methods: {
    async acknowledgeRequest() {
      try {
        this.loading = true;
        let response = await this.$_acknowledgeRequest({
          "name": "process_handoff",
          "orgId": this.orgId,
        });
        console.log(response);
        this.generateToast("Acknoledged!!", "success");

        this.loading = false;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
        // console.log(error);
      }
    },
  }
};
</script>

<style scoped>
.delete-modal {
  text-align: center;
}
</style>
